import './App.css';
import React from "react";

function BookingDetail() {
  return (
    <div>
        <h1>Home Page</h1>
    </div>
  );
}

export default BookingDetail;
